module.exports = __webpack_public_path__ + "img/email-message.7b0f47da.jpg";